// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"e7c83b05","320":"2cd031a7","604":"fb6b9c92","616":"224ad6b1","849":"45535cd9","875":"7b41ed76","893":"88d5e677","950":"78fc41d9"}[chunkId] + ".chunk.js";
};